var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisabilityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wheelchair-sharp-solid 1",
    clipPath: "url(#clip0_2649_654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5 0C11.1962 0 11.8639 0.276562 12.3562 0.768845C12.8484 1.26113 13.125 1.92881 13.125 2.625C13.125 3.32119 12.8484 3.98887 12.3562 4.48116C11.8639 4.97344 11.1962 5.25 10.5 5.25C9.80381 5.25 9.13613 4.97344 8.64384 4.48116C8.15156 3.98887 7.875 3.32119 7.875 2.625C7.875 1.92881 8.15156 1.26113 8.64384 0.768845C9.13613 0.276562 9.80381 0 10.5 0ZM2.625 19.25C2.625 22.6352 5.36484 25.375 8.75 25.375C11.4789 25.375 13.7977 23.5867 14.5852 21.1203L17.0844 21.9187C15.9578 25.4461 12.6547 28 8.75 28C3.91562 28 0 24.0844 0 19.25C0 14.968 3.07891 11.4023 7.14219 10.6477L7.62344 13.2289C4.77969 13.7539 2.625 16.2531 2.625 19.25ZM8.36719 7H10.5H12.25H13.6828L13.9617 8.40547L14.2078 9.625H18.375H20.125V13.125H18.375H14.9078L15.4328 15.75H21H22.2141L22.6406 16.8875L24.6695 22.3016L25.2547 22.1047L26.9117 21.5469L28.0328 24.8609L26.3758 25.4187L24.1883 26.157L22.5859 26.6984L21.9898 25.1125L19.7859 19.25H14.0328C14.0109 19.25 13.9891 19.25 13.9617 19.25H12.25H10.8172L10.5383 17.8445L8.78828 9.09453L8.36719 7Z",
    fill: "#6210CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2649_654"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabilityIcon);
export default __webpack_public_path__ + "static/media/disability_icon.cc966faef5293809d5e89c5b914631ff.svg";
export { ForwardRef as ReactComponent };